import { useEffect, useState } from 'react';
import { getMirroredDeclaration } from 'store/declarations/client';
import { Declaration } from 'store/declarations/declaration';
import { MIRRORED_DECLARATIONS_PAGE_SIZE } from '../constants';
import { getLinkedMirroredDeclarations } from '../getLinkedMirroredDeclarations';
import { sortMirroredDeclarations } from '../sortMirroredDeclarations';

const CLOSED_RESULT = { declarations: [], isLoading: false, hasError: false };

export const useMirroredDeclarationsOnOpen = (declaration: Declaration | undefined, isOpen: boolean) => {
    const declarationId = declaration?.id;

    const [listedDeclarations, setListedDeclarations] = useState<Declaration[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [hasError, setHasError] = useState(false);

    useEffect(() => {
        if (!isOpen || !declarationId) return;

        let isCurrent = true;
        setListedDeclarations([]);
        setHasError(false);
        setIsLoading(true);

        getMirroredDeclaration(declarationId, { size: MIRRORED_DECLARATIONS_PAGE_SIZE })
            .then(({ list }) => {
                if (isCurrent) setListedDeclarations(sortMirroredDeclarations(list));
            })
            .catch((error) => {
                console.error('Failed to fetch mirrored declarations', error);
                if (isCurrent) setHasError(true);
            })
            .finally(() => {
                if (isCurrent) setIsLoading(false);
            });

        return () => {
            isCurrent = false;
        };
    }, [isOpen, declarationId]);

    if (!isOpen) return CLOSED_RESULT;

    return {
        declarations: getLinkedMirroredDeclarations(declaration, listedDeclarations),
        isLoading,
        hasError,
    };
};
